var $a33d71dc804cc59e$exports = {};
$a33d71dc804cc59e$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "Kohdetta ".concat(args.item, " ei valittu.");
  },
  "longPressToSelect": "Siirry valintatilaan painamalla pitk\xE4\xE4n.",
  "select": "Valitse",
  "selectedAll": "Kaikki kohteet valittu.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Ei yht\xE4\xE4n kohdetta valittu",
      one: function one() {
        return "".concat(formatter.number(args.count), " kohde valittu");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " kohdetta valittu");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " valittu.");
  }
};
export { $a33d71dc804cc59e$exports as default };